export const useBreadcrumb = () => {
  const leafName = useState('leafName',()=>'');
  const leafId = useState('leafId',()=>'');

  const setName = (name: string) => {
    leafName.value = name;
  };
  const setId = (id: string) => {
    leafId.value = id;
  };

  return { 
    leafName, 
    leafId,
    setName,
    setId
  };
};